import React from "react";
import {connect} from "react-redux";
import { Switch, Route } from "react-router-dom";


import Form from 'views/Clients/Form'
import List from 'views/Clients/List'

// Actions
import {
  setClientViewFilter,
  clearClientsList
} from 'actions/clients'

class Clients extends React.Component {
  componentWillUnmount() {
    this.props.setClientViewFilter({filterName: 'selectedProfileId', value: null})
    this.props.setClientViewFilter({filterName: 'selectedIbId', value: null})
    this.props.clearClientsList()
  }
  render() {
    const {match}=this.props;
    return (

          <Switch>
            <Route path={`${match.path}/add`} component={Form}/>
            <Route path={`${match.path}/:id/ib/:ibid/profile/:profileid`} component={Form}/>
            <Route component={List}/>
          </Switch>

    );
  }
}
const state=(state)=>({})
const dispatch=(dispatch)=>({
  setClientViewFilter: (data) => dispatch(setClientViewFilter(data)),
  clearClientsList: () => dispatch(clearClientsList())
})
export default connect(state,dispatch)(Clients);



// WEBPACK FOOTER //
// ./src/views/Clients/Clients.jsx